import axios from "axios";
import apiEndpoints from "../config/apiEndpoints";
import { fetchData } from "../utils/utils";

const FetchPickupProgress=async(key)=>{
    try {
        const response=await axios.get(apiEndpoints?.TV?.PICKUP_IN_PROGRESS(key));
        return response   
    } catch (error) {
        console.error("Error fetching webshop products info", error);
        return null;    
    }
}

const FetchPickupReady=async(key)=>{
    try {
        const response=await axios.get(apiEndpoints?.TV?.PICKUP_READY(key));
        return response   
    } catch (error) {
        console.error("Error fetching webshop products info", error);
        return null;    
    }
}

const fetchDineInProgress=async(key)=>{
    try {
        const response=await axios.get(apiEndpoints?.TV?.DINE_IN_PROGRESS(key));
        return response   
    } catch (error) {
        console.error("Error fetching webshop products info", error);
        return null;    
    }
}

const fetchDineInReady=async(key)=>{
    try {
        const response=await axios.get(apiEndpoints?.TV?.DINE_IN_READY(key));
        return response   
    } catch (error) {
        console.error("Error fetching webshop products info", error);
        return null;    
    }
}
export {
FetchPickupProgress,FetchPickupReady,fetchDineInProgress,fetchDineInReady
}